<div >
	<guild [person]="user" ></guild>
</div>
